<script lang="ts">import { initLogo } from '../../../../js-v2/stores/logo-store';
import FlyoutToggle from '../../shared/FlyoutToggle/FlyoutToggle.svelte';
import HomeLink from '../../shared/HomeLink/HomeLink.svelte';
import ItemList from '../../shared/Cart/ItemList/ItemList.svelte';
import NavList from './NavList/NavList.svelte';
import Scrim from './Scrim/Scrim.svelte';
import Status from '../../shared/Cart/Status/Status.svelte';
import SearchDropdown from './SearchDropdown.svelte';
import { activeDropdownStore } from '../../../../js-v2/stores/desktop-nav-stores';
import { getSearchOptionsStore } from '../../../Search/SearchProvider.svelte';
import CtaNav from './CtaNav/CtaNav.svelte';
import AskSquareNavButton from './AskSquareNavButton.svelte';
const { id = '', homeLink = undefined, primaryNavItems = [], secondaryNavItems = [], enableAskSquare = false, cart = undefined, primaryCtaButton = undefined, secondaryCtaButton = undefined, ctaButtonStyleV1 = false, toggleAskSquare = () => { }, } = $props();
let desktopNavHeight = $state(0);
const searchOptions = getSearchOptionsStore();
// Initialize logo context at the parent level so all children share it
initLogo(homeLink?.props?.logo || 'LogoJewel');
</script>

<div
  class="DesktopNav"
  data-global-nav-desktop-v2
  bind:clientHeight={desktopNavHeight}
  data-entry-id={id}
  style:--desktop-nav-height={`${desktopNavHeight}px`}
>
  <div class="left-slot">
    <HomeLink
      id={homeLink?.contentfulEntryId}
      title={homeLink?.props?.title}
      logo={homeLink?.props?.logo}
      url={homeLink?.props?.url}
    />
  </div>

  <div class="middle-slot">
    <NavList navItems={primaryNavItems} enableInactiveState={true} />
  </div>

  <div class="right-slot">
    <NavList navItems={secondaryNavItems} shouldRenderFlyout={true} enableLinkHoverOpacity={true} />

    {#if enableAskSquare}
      <AskSquareNavButton {toggleAskSquare} />
    {/if}

    {#if $searchOptions.isEnabled && !enableAskSquare}
      <SearchDropdown />
    {/if}

    {#if cart}
      <FlyoutToggle id={cart.contentfulEntryId} title={cart.props.title} alignment="right" renderCartButton={true}>
        <Status
          statusZero={cart.props.statusZeroItems}
          statusOne={cart.props.statusOneItem}
          statusMany={cart.props.statusManyItems}
          slideInFrom="top"
        />
        {#if primaryNavItems}
          <ItemList navItems={cart.props.primaryNavItems} cartPrimary={true} listStartingIndex={1} slideInFrom="top" />
        {/if}
        {#if secondaryNavItems}
          <ItemList
            navItems={cart.props.secondaryNavItems}
            listStartingIndex={1 + primaryNavItems?.length || 0}
            slideInFrom="top"
          />
        {/if}
      </FlyoutToggle>
    {/if}

    <CtaNav {primaryCtaButton} {secondaryCtaButton} {ctaButtonStyleV1} />
  </div>

  <div
    class="dropdown-background"
    class:has-slide-in={$activeDropdownStore.showSlideInAnimation}
    style:--dropdown-background-height={`${$activeDropdownStore.contentHeight}px`}
  ></div>
</div>

<Scrim />

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.DesktopNav {
  padding-left: 22px;
  padding-right: 22px;
  box-sizing: border-box;
  position: relative;
  min-width: 320px;
  z-index: 3;
  padding-top: 4px;
  padding-bottom: 4px;
  background-color: var(--color-background, var(--color-neutral-1000, #fff));
  color: var(--color-text, var(--color-neutral-000, #000000));
  display: none;
  gap: 12px;
}
@media (min-width: 105rem) {
  .DesktopNav {
    --nav-outer-gutter-base: calc(var(--space-10) / 2);
    --nav-outer-gutter: max(var(--nav-outer-gutter-base), var(--dynamic-gutter));
    padding-left: calc(22px + var(--nav-outer-gutter)) !important;
    padding-right: calc(22px + var(--nav-outer-gutter)) !important;
  }
}
@media (min-width: 64rem) {
  .DesktopNav {
    display: flex;
  }
}
.DesktopNav .left-slot,
.DesktopNav .middle-slot,
.DesktopNav .right-slot {
  display: flex;
  align-items: center;
}
.DesktopNav .right-slot {
  width: 100%;
  justify-content: flex-end;
}
.DesktopNav .dropdown-background {
  position: absolute;
  z-index: -1;
  left: 0;
  top: calc(var(--desktop-nav-height) - 4px);
  width: 100%;
  height: var(--dropdown-background-height);
  background-color: var(--color-background, var(--color-neutral-1000, #fff));
  transition: height 100ms ease-in-out;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}
.DesktopNav .dropdown-background.has-slide-in {
  transition: height 300ms cubic-bezier(0.4, 0, 0.6, 1);
}</style>
